import { addDebugEvent } from '../model/debugEventStore';

/**
 * Emit a debug event into the in-app debug timeline.
 *
 * Callers are free to use any `category` string they like -- the debug panel
 * derives its filter list dynamically from observed categories.
 */
export function emitDebugEvent(category: string, summary: string, data?: unknown): void {
  addDebugEvent({ category, summary, data });
}
